import { combineReducers } from 'redux';
import Intake from './intake';

const Reducers = () => combineReducers({
    intake: Intake,
});

export default Reducers;
